import {
  getV1DealerIdApplicationAppIdLand,
  postV1DealerIdApplicationAppIdLandAlreadyOwned,
  postV1DealerIdApplicationAppIdLandCurrentlyFinanced,
  postV1DealerIdApplicationAppIdLandFamily,
  postV1DealerIdApplicationAppIdLandLeasing,
  postV1DealerIdApplicationAppIdLandPurchasing,
  postV1DealerIdApplicationAppIdLandReservation,
  type DtoCreateLandAlreadyOwnedReq,
  type DtoCreateLandCurrentlyFinancedReq,
  type DtoCreateLandToBeLeasedReq,
  type DtoCreateLandToBePurchasedReq,
} from "@porchpass/api-client";
import { assertApiSuccess } from "../utils/assertApiSuccess";
import { EMPTY_REQUEST_BODY } from "./constants";
import { lazyDealerId, requireApplicationId, type DomainIds } from "./types";

export function createLandDomain(ids: DomainIds) {
  const getDealerId = lazyDealerId(ids);

  return {
    getLand: async (applicationId?: string) => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response = await getV1DealerIdApplicationAppIdLand(
        getDealerId(),
        appId,
      );
      return assertApiSuccess(response);
    },

    createLandAlreadyOwned: async (
      body: DtoCreateLandAlreadyOwnedReq,
      applicationId?: string,
    ) => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response = await postV1DealerIdApplicationAppIdLandAlreadyOwned(
        getDealerId(),
        appId,
        body,
      );
      return assertApiSuccess(response);
    },

    createLandCurrentlyFinanced: async (
      body: DtoCreateLandCurrentlyFinancedReq,
      applicationId?: string,
    ) => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response =
        await postV1DealerIdApplicationAppIdLandCurrentlyFinanced(
          getDealerId(),
          appId,
          body,
        );
      return assertApiSuccess(response);
    },

    createLandPurchasing: async (
      body: DtoCreateLandToBePurchasedReq,
      applicationId?: string,
    ) => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response = await postV1DealerIdApplicationAppIdLandPurchasing(
        getDealerId(),
        appId,
        body,
      );
      return assertApiSuccess(response);
    },

    createLandLeasing: async (
      body: DtoCreateLandToBeLeasedReq,
      applicationId?: string,
    ) => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response = await postV1DealerIdApplicationAppIdLandLeasing(
        getDealerId(),
        appId,
        body,
      );
      return assertApiSuccess(response);
    },

    createLandFamily: async (applicationId?: string) => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response = await postV1DealerIdApplicationAppIdLandFamily(
        getDealerId(),
        appId,
        EMPTY_REQUEST_BODY,
      );
      return assertApiSuccess(response);
    },

    createLandReservation: async (applicationId?: string) => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response = await postV1DealerIdApplicationAppIdLandReservation(
        getDealerId(),
        appId,
        EMPTY_REQUEST_BODY,
      );
      return assertApiSuccess(response);
    },
  };
}
